import React from 'react';
import PropTypes from 'prop-types';

export default function InstagramPost({
  post,
  toggleLightbox,
  setImageIndex,
  index,
}) {
  return (
    <button
      type="button"
      name="instagram-post"
      aria-label="instagram-post"
      className="instagram-post-outer"
      onClick={() => {
        setImageIndex(index);
        toggleLightbox(true);
      }}
    >
      <img
        className="instagram-post lazyload"
        data-src={post.media_url}
        alt="Instagram post"
        title="Instagram Post Image"
      />
    </button>
  );
}

InstagramPost.propTypes = {
  post: PropTypes.object,
  toggleLightbox: PropTypes.func.isRequired,
  setImageIndex: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
